import React from "react";
import {
  Body,
  ProjectBody,
} from "../../assets/styles/styled-components/GlobalStyles";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import techsauce from "../../assets/images/techsauce.png";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";

export default function Meplug() {
  const collapsed = useSelector((state) => state.sidebar.isCollaped);

  return (
    <Body isCollapsed={collapsed}>
      <ProjectBody>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "100vh" }}
        >
          <Grid item xs={12} sm={7}>
            <h2>meplug</h2>
            <p>
              Meplug is a smart outlet that created for installation in the
              parking lot inside the condominium. It is able to charge both
              electric cars as well as other electrical appliances. Meplug is also able to
              track electricity usage, charge and pay through the application.
            </p>
            <div style={{ paddingBottom: 50 }}>
              <AwesomeSlider>
                <div style={{ backgroundColor: "#14141f" }}>
                  <img
                    width={"100%"}
                    height={"auto"}
                    src={require("../../assets/images/meplug/meplug_bg.jpg")}
                    alt="Meplug overall design"
                  />
                </div>
                <div style={{ backgroundColor: "#14141f" }}>
                  <img
                    width={"100%"}
                    height={"auto"}
                    src={require("../../assets/images/meplug/Website.png")}
                    alt="Certificate scholarship"
                  />
                </div>
              </AwesomeSlider>
            </div>
          </Grid>
          <Grid item xs={12} sm={5}>
            <div className="right-image">
              <img
                src={require("../../assets/images/meplug/prototype_awards.jpg")}
                height={200}
                alt="The best prototype awards"
              />
              <p>"The Best Prototype Award - WEDO, SCG"</p>
              <img src={techsauce} height={200} alt="techsauce" />
              <p>"Pitched on Techsauce Global Summit 2022"</p>
            </div>
          </Grid>
        </Grid>
      </ProjectBody>
    </Body>
  );
}
